import { NoSymbolIcon } from '@heroicons/react/24/outline';
import { XCircleIcon } from '@heroicons/react/24/solid';
import { useSelector } from 'react-redux';
import AccountNotFound from '@/components/UI/AccountNotFound';
import { useCurrentAccountData } from '../../../hooks/ReactQueryHooks/useCurrentAccountQuery';
import { developerApplicationSelector } from '../../../store';

const ApplicationSubmitFail = () => {
  const currentAccountInfo = useCurrentAccountData({});
  const accountSubdomain = currentAccountInfo?.data?.data?.subdomain;
  const { submitSuccess } = useSelector(developerApplicationSelector).opportunityMain;

  if (!submitSuccess) {
    return (
      <div className='mx-auto flex flex-col bg-white px-5 py-6 rounded-md max-w-xl text-center justify-center items-center shadow-lg'>
        <div className='bg-red-50 p-4 rounded-full my-4'>
          <NoSymbolIcon className='h-10 w-10 text-tertiaryColor-normal' />
        </div>
        <h2 className='m-0'>Unauthorized</h2>
        <p className='mt-2 mb-5'>You are not authorized to access this page without submitting an application.</p>
      </div>
    );
  }

  if (accountSubdomain) {
    return (
      <div className='container mx-auto flex justify-center'>
        <div className='bg-white p-4 rounded-md w-1/2 flex flex-col justify-center items-center gap-6 mb-10 text-center'>
          <div className='flex items-center gap-2 text-tertiaryColor-normal'>
            <XCircleIcon className='h-5 w-5' />
            <h2 className='m-0 '>Rejected</h2>
          </div>
          <h3>Your Application has been Rejected!</h3>
          <p>
            You have already submitted this application. You will receive a notification once decision has been made on your application.
          </p>
          <span>You can close your browser now.</span>
        </div>
      </div>
    );
  }
  return <AccountNotFound />;
};

export default ApplicationSubmitFail;
